/**
 * 计算 UTF-8 编码字符串长度
 * @param inputStr
 * @returns {number}
 */
export const counterStrLength = function (inputStr) {
  let totalLength = 0
  /* 计算utf-8编码情况下的字符串长度 */
  for (let i = 0; i < inputStr.length; i++) {
    if (inputStr.charCodeAt(i) <= parseInt('0x7F')) {
      totalLength += 1
    } else if (inputStr.charCodeAt(i) <= parseInt('0x7FF')) {
      totalLength += 2
    } else if (inputStr.charCodeAt(i) <= parseInt('0xFFFF')) {
      totalLength += 3
    } else if (inputStr.charCodeAt(i) <= parseInt('0x1FFFFF')) {
      totalLength += 4
    } else if (inputStr.charCodeAt(i) <= parseInt('0x3FFFFFF')) {
      totalLength += 5
    } else {
      totalLength += 6
    }
  }
  return totalLength
}

/**
 * 将src对象属性copy到dist对象中
 * @param src
 * @param dist
 */
export const copyObject = function (src, dist) {
  for (const k in src) {
    // eslint-disable-next-line no-prototype-builtins
    if (dist.hasOwnProperty(k)) {
      dist[k] = src[k]
    }
  }
}

/**
 * 格式化时间
 *
 * @param fmt
 * @param date
 * @returns {*}
 */
export const dateFormat = function (fmt, date) {
  let ret
  const opt = {
    'Y+': date.getFullYear().toString(),
    'm+': (date.getMonth() + 1).toString(),
    'd+': date.getDate().toString(),
    'H+': date.getHours().toString(),
    'M+': date.getMinutes().toString(),
    'S+': date.getSeconds().toString(),
  }
  for (const k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
    }
  }
  return fmt
}

export const formatTime = function (time) {
  if (!time) return ''
  if (time / 10000000000 < 1) {
    time = time * 1000
  }
  return dateFormat('YYYY-mm-dd HH:MM', new Date(time))
}

/**
 * 格式化时间（精确到秒）
 *
 * @param time {number} - 时间戳（秒或毫秒）
 * @returns {string} 格式化后的字符串，例如：2025-04-07 08:08:59
 */
export const formatTimeWithSeconds = function (time) {
  if (!time) return ''
  if (time / 10000000000 < 1) {
    time = time * 1000
  }
  return dateFormat('YYYY-mm-dd HH:MM:SS', new Date(time))
}

export const getZoneTime = function (date, zone) {
  if (!date || !zone || date === '') {
    return ''
  }
  const targetDate = new Date(date + date.getTimezoneOffset() * 60 * 1000 + zone * 60 * 60 * 1000)
  return targetDate.getTime()
}

/**
 * 将日期格式转换成时间戳
 *
 * @param date
 * @returns {number}
 */
export const parseDate = function (date) {
  return Date.parse(date) / 1000
}

export const toMinSecFormat = function (seconds) {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60

  if (minutes === 0) {
    return `${remainingSeconds}s`
  } else {
    return `${minutes}分${remainingSeconds}秒`
  }
}
